'use client';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import Link from 'next/link';
import { Brand } from '~/components/brand';
import { WalkthroughButton, WalkthroughScope } from './home/walkthrough';
import s from './home/home.module.css';
const links = [
  ['How it works', '/#how'],
  ['Early warnings', '/#early'],
  ['Try a lookup', '/demo'],
] as const;
export function MarketingHeader() {
  const [open, setOpen] = useState(false);
  return (
    <WalkthroughScope>
      <header
        className={`${s.page} sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur`}
      >
        <a className={s.skip} href="#main">
          Skip to content
        </a>
        <div className={s.header}>
          <div className={s.wrap}>
            <Brand />
            <nav className={s.nav} aria-label="Main navigation">
              <div className={s.navlinks}>
                {links.map(([label, href]) => (
                  <Link key={href} href={href}>
                    {label}
                  </Link>
                ))}
              </div>
              <Link href="/auth/sign-in" className="hidden lg:inline" data-test="marketing-login">
                Sign in
              </Link>
              <WalkthroughButton className={`${s.btn} ${s.sm}`} test="marketing-add-ava">
                Add Ava
              </WalkthroughButton>
              <button
                className="flex size-9 items-center justify-center lg:hidden"
                aria-label="Open navigation"
                aria-expanded={open}
                aria-controls="mobile-navigation"
                onClick={() => setOpen(!open)}
              >
                <Menu size={22} aria-hidden="true" />
              </button>
            </nav>
          </div>
        </div>
        {open && (
          <nav
            id="mobile-navigation"
            aria-label="Mobile navigation"
            className="flex flex-col gap-2 border-t px-6 py-4 lg:hidden"
          >
            {links.map(([label, href]) => (
              <Link className="py-2" key={href} href={href} onClick={() => setOpen(false)}>
                {label}
              </Link>
            ))}
            <Link href="/auth/sign-in" className="border-t py-2" data-test="mobile-marketing-login">
              Sign in
            </Link>
          </nav>
        )}
      </header>
    </WalkthroughScope>
  );
}
